const CHANNEL_NAME = "sniffer-operation-tabs";
// Background tabs may run timers only about once a minute, so a tab counts as gone
// only after several missed heartbeats (e.g. it crashed without saying goodbye).
const HEARTBEAT_INTERVAL = 30000;
const STALE_AFTER = 150000;

// One presence per browser tab; the channel lives outside the store state.
let channel = null;
let heartbeatTimer = null;
let ownTabId = null;

function post(type) {
  if (channel) channel.postMessage({ type: type, tabId: ownTabId });
}

export default {
  startPresence(context) {
    // Already announced, or the browser has no BroadcastChannel (then simply no warning).
    if (channel || typeof BroadcastChannel === "undefined") return;

    ownTabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = event => context.dispatch("receiveMessage", event.data);

    post("announce");

    heartbeatTimer = setInterval(() => {
      post("heartbeat");
      context.commit("removeStaleOtherTabs", Date.now() - STALE_AFTER);
    }, HEARTBEAT_INTERVAL);
  },
  stopPresence(context) {
    if (!channel) return;

    post("leave");

    clearInterval(heartbeatTimer);
    channel.close();

    channel = null;
    heartbeatTimer = null;
    ownTabId = null;

    context.commit("clearOtherTabs");
    context.commit("setWarningDismissed", false);
  },
  receiveMessage(context, message) {
    if (!message || !message.tabId || message.tabId === ownTabId) return;

    if (message.type === "leave") {
      context.commit("removeOtherTab", message.tabId);

      return;
    }

    const isNewTab = !(message.tabId in context.state.otherTabs);

    context.commit("setOtherTab", { tabId: message.tabId, seenAt: Date.now() });

    // An additional operations tab brings the warning back even if it was closed before.
    if (isNewTab) context.commit("setWarningDismissed", false);

    // Answer a newcomer right away so it knows about this tab without waiting for a heartbeat.
    if (message.type === "announce") post("heartbeat");
  },
  dismissWarning(context) {
    context.commit("setWarningDismissed", true);
  }
};
